import { useEffect } from "react";

export function useScrollIntoView(refs, activeStep) {
  useEffect(() => {
    //https://stackoverflow.com/questions/71400009/stepper-functionality-using-react
    setTimeout(() => refs.current[activeStep]?.scrollIntoView({ behavior: "smooth", block: "start" }), 350);
  }, [refs, activeStep]);
}
